import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    Close: {
        id: 'Profile.Components.PictureGallery.Close',
        defaultMessage: 'Close gallery',
    },
});
